import React, { Fragment, createContext } from "react";
import { Navber, Footer, CartModal, TopBanner } from "../partials";
import FeaturesNewsletter from "../partials/FeaturesNewsletter";
import ScrollToTopButton from "../partials/ScrollToTopButton";
import LoginSignup from "../auth/LoginSignup";

export const LayoutContext = createContext();

const Layout = ({ children }) => {
  return (
    <Fragment>
      <div className="flex-grow">
        <TopBanner />
        <Navber />
        <LoginSignup />
        <CartModal />
        {/* All Children pass from here */}
        {children}
      </div>
      <ScrollToTopButton />
  <FeaturesNewsletter />
  <Footer />
    </Fragment>
  );
};

export default Layout;
